import { Button, Card } from 'antd';
import React from 'react';
import { useCurrencyConverter } from '../../context/currencyHook';
import { useCurrency } from '../../context/CurrencyContext';
import config from '../../config';

const VehiclePlans = ({ vehicles, loading, setSelectedVehicle, selectedVehicle, setSelectedVehicleReturn, selectedVehicleReturn, isReturn, onewayMinutes, returnMinutes }) => {

    const convertCurrency = useCurrencyConverter();
    const { currency } = useCurrency();

    const handleClick = (vehicle) => {
        setSelectedVehicle(vehicle)
    }

    const handleClickReturn = (vehicle) => {
        setSelectedVehicleReturn(vehicle)
    }

    const sortVehiclesByPrice = (vehicles, minutes) => {
        return [...vehicles].sort((a, b) => {
            const priceA = (a?.basePricePKR || 0) + Math.ceil((a?.perMinutePricePKR || 0) * minutes);
            const priceB = (b?.basePricePKR || 0) + Math.ceil((b?.perMinutePricePKR || 0) * minutes);
            return priceA - priceB;
        });
    }

    return (
        <div className="vehicle-plans">
            <div className='text-lg !text-white font-bold mt-4' style={{ color: 'black', backgroundColor: '#00803e' }}>
                Select One Way Vehicle
            </div>
            <div className='grid lg:grid-cols-4 md:grid-cols-3 mx-auto !mt-6'>
                {
                    sortVehiclesByPrice(vehicles || [], onewayMinutes)?.map((vehicle) => {
                        return (
                            <Card
                                onClick={() => { handleClick(vehicle) }}
                                className='!mx-auto mb-12 !mt-8 vehicle-card cursor-pointer'
                                hoverable
                                style={{
                                    width: 240,
                                    backgroundColor: '#E5E4E2',
                                    borderRadius: '8px',
                                    border: selectedVehicle?.id == vehicle?.id ? '5px solid #00803e' : ''
                                }}
                                cover={<img alt="example" className='h-[138px]' style={{
                                    objectFit: 'contain'
                                }} src={`${config.API_URL}/${vehicle.picture}`} />}
                            >
                                <div className='text-lg font-bold' style={{ backgroundColor: '#00803e', color: 'white' }}>
                                    {vehicle.name}
                                </div>
                                <div className='text-base pt-1 font-semibold'>
                                    {vehicle.passengersCapacity}  {' Passengers'}
                                </div>
                                <div className='text-base pt-1 font-semibold'>
                                    {vehicle.luggage}
                                </div>
                                <div className='text-base pt-1 font-semibold'>
                                    {currency} {convertCurrency((vehicle?.basePricePKR || 0) + Math.ceil((vehicle?.perMinutePricePKR || 0) * onewayMinutes))}
                                </div>
                                <Button type='button' className='w-full mt-2' style={{
                                    backgroundColor: '#00803e',
                                    color: '#ffffff'
                                }}>Select</Button>
                            </Card>
                        )
                    })
                }
            </div>
            {
                loading &&
                'Loading...'
            }
            {isReturn && <div className='text-lg !text-white !mt-8 font-bold' style={{ color: 'black', backgroundColor: '#00803e' }}>
                Select Return Vehicle
            </div>}
            <div className='grid lg:grid-cols-4 md:grid-cols-3 mx-auto !mt-6'>
                {
                    isReturn && sortVehiclesByPrice(vehicles || [], returnMinutes)?.map((vehicle) => {
                        return (
                            <Card
                                onClick={() => { handleClickReturn(vehicle) }}
                                className='!mx-auto mb-12 !mt-8 vehicle-card cursor-pointer'
                                hoverable
                                style={{
                                    width: 240,
                                    backgroundColor: '#E5E4E2',
                                    borderRadius: '8px',
                                    border: selectedVehicleReturn?.id == vehicle?.id ? '5px solid #00803e' : ''
                                }}
                                cover={<img alt="example" className='h-[138px]' style={{
                                    objectFit: 'contain'
                                }} src={`${config.API_URL}/${vehicle.picture}`} />}
                            >
                                <div className='text-lg font-bold' style={{ backgroundColor: '#00803e', color: 'white' }}>
                                    {vehicle.name}
                                </div>
                                <div className='text-base pt-1 font-semibold'>
                                    {vehicle.passengersCapacity + ' Passengers'}
                                </div>
                                <div className='text-base pt-1 font-semibold'>
                                    {vehicle.luggage}
                                </div>
                                <div className='text-base pt-1 font-semibold'>
                                    {currency} {convertCurrency((vehicle?.basePricePKR || 0) + Math.ceil((vehicle?.perMinutePricePKR || 0) * returnMinutes))}
                                </div>
                                <Button type='button' className='w-full mt-2' style={{
                                    backgroundColor: '#00803e',
                                    color: '#ffffff'
                                }}>Select</Button>
                            </Card>
                        )
                    })
                }
            </div>
            {
                isReturn && loading &&
                'Loading...'
            }

        </div>
    );
};

export default VehiclePlans;
